// 혈당
const B = (value) => 180 < value ? 'bad' : value < 70 ? 'low' : 'good';
// GMI
const GMI = (value) => value < 7 ? 'good' : 'bad';
// CV
const CV = (value) => value <= 36 ? 'good' : 'bad';
// TAR
const TAR = (value) => value < 25 ? 'good' : 'bad';
// TIR
const TIR = (value) => 70 < value ? 'good' : 'bad';
// TBR
const TBR = (value) => value < 4 ? 'good' : 'low';
// Delta-Positive is Good
const P = (value) => 0 < value ? 'good' : 'bad';
// Delta-Negativie is Good
const N = (value) => value < 0 ? 'good' : 'bad';
const selection = {
  B,
  GMI,
  CV,
  TAR,
  TIR,
  TBR,
  P,
  N,
};

export default function CHECK_COLORS(type, value) {
  return selection[type](value);
}